import type { Entregador, FiltroStatusRota, PedidoRoteirizavel } from "../models/roteirizacaoModel"

export enum RoteirizacaoActionsTypes {
    CARREGAR_DADOS = "CARREGAR_DADOS",
    SET_DATA = "SET_DATA",
    SET_FILTRO_STATUS = "SET_FILTRO_STATUS",
    SET_ENTREGADOR = "SET_ENTREGADOR",
    TOGGLE_PEDIDO = "TOGGLE_PEDIDO",
    SELECIONAR_IDS = "SELECIONAR_IDS",
    LIMPAR_SELECAO = "LIMPAR_SELECAO",
    SET_USO = "SET_USO",
    APLICAR_ASSOCIACAO = "APLICAR_ASSOCIACAO",
}

export type RoteirizacaoAction =
    | {
          type: RoteirizacaoActionsTypes.CARREGAR_DADOS
          payload: { pedidos: PedidoRoteirizavel[]; entregadores: Entregador[] }
      }
    | { type: RoteirizacaoActionsTypes.SET_DATA; payload: string }
    | { type: RoteirizacaoActionsTypes.SET_FILTRO_STATUS; payload: FiltroStatusRota }
    | { type: RoteirizacaoActionsTypes.SET_ENTREGADOR; payload: number | null }
    | { type: RoteirizacaoActionsTypes.TOGGLE_PEDIDO; payload: number }
    | { type: RoteirizacaoActionsTypes.SELECIONAR_IDS; payload: number[] }
    | { type: RoteirizacaoActionsTypes.LIMPAR_SELECAO }
    | {
          type: RoteirizacaoActionsTypes.SET_USO
          payload: {
              usados: number
              limite: number
              ilimitado: boolean
              idParametroContador: number | null
          }
      }
    | {
          type: RoteirizacaoActionsTypes.APLICAR_ASSOCIACAO
          payload: {
              ids: number[]
              nomeEntregador: string
              usados: number
              idParametroContador: number | null
          }
      }
